/**
 * @constant
 */
const DevTypes = {
    GATEWAY: "GW",
    BRIDGE: "BR",
    SCALE: "SC",
    CAGE: "CA",
    CAGE_2WAY: "CA_2",
    CLIMATE: "CL",
    CLIMATE_SK3: "CL_SK3",
    CLIMATE_SK4: "CL_SK4",
    DISPENSER: "DI",
    DISPENSER_NRF: "DI_NRF",
    DISPENSER_NRF_MULTI: "DI_MULTI",
    BRIDGE_WORK: "BR_WORK",
    BRIDGE_CONF: "BR_CONF",
    DI_TIME: "DI_TIME",
    BROADCAST: "BROADCAST",
    THERMOEYE: "TE",
    ANTENNA_RFID: "ANT",
    WATER_FLOW_METER: "MBUS_WATER",
    WIRELESS_WATER_FLOW_METER: "WMBUS_WATER",
    ELECTRICITY_FLOW_METER: "MBUS_ELECTRIC",
    ELECTRICITY_FLOW_METER_MODBUS: "ELECTRIC",
    CHAIN_FEEDING: "SP",
    SMALL_CAGE: "PS",
    UNIVERSAL: "UNIVERSAL",
    SILO_RADAR: "SILO_RADAR",
    RTE485: "RTE485",
    TTL_OVER_ETH: "TTL_OVER_ETH",
    MODBUS_RELAY: "MODBUS_RELAY",
    VEHICLE_WEIGHT_R320: "R320",
    ALARM_CONTROL_PANEL: "FARM_WATCH",
    TEMP_SENSOR: "FARM_WATCH_TEMP",
    SILO_SENSOR: "FARM_WATCH_SILO",
    WATER_SENSOR: "FARM_WATCH_WATER",
    CHANNEL_SENSOR: "FARM_WATCH_CHAN",
    PROBE_SENSOR: "FARM_WATCH_PROBE",
    DOSATRON: "DOS",
    BRIDGE_MBUS: "BR_MBUS",
    SP_ETH: "SP_ETH",
    CAMERA: "CAM",

};

module.exports = DevTypes;
